//
// Generated class DepartmentPool
//

/// <reference path="DepartmentPool_ManagedObject.ts" />

class DepartmentPool extends DepartmentPool_ManagedObject
{

}
